<template>
  <a-list :data-source="changelogs" item-layout="horizontal">
    <a-list-item slot="renderItem" slot-scope="item">
      <a-comment>
        <a slot="author">{{ item.creator.nickname }}</a>
        <a-avatar slot="avatar" :src="item.creator.avatar_url" alt="Han Solo" />
        <vditor-preview slot="content" :content="item.after_content" />
        <a-tooltip slot="datetime">
          <span v-if="item.before_status !== item.after_status"> {{ status(item.before_status, item.after_status) }} </span>
          <span v-if="item.before_handler !== item.after_handler"> {{ handler(item.before_handler, item.after_handler) }} </span>
        </a-tooltip>
        <template slot="actions">
          <span key="comment-basic-reply-to">{{ item.created_time }}</span>
        </template>
      </a-comment>
    </a-list-item>
  </a-list>
</template>

<script>
import { problemChangelog } from '@/api/event/problem';
import { problemStatus } from '@/utils/dictionary';
import VditorPreview from '@/components/VditorEditor/preview';
export default {
  components: { VditorPreview },
  data() {
    return {
      problemStatus,
      loading: true,
      changelogs: [],
      problemId: parseInt(this.$route.query.problemId) || null
    };
  },
  computed: {
    status() {
      return (before_status, after_status) => {
        if (before_status !== null && after_status !== null) {
          return `状态: 从「${problemStatus[before_status].label}」变更为「${problemStatus[after_status].label}」`;
        }
      };
    },
    handler() {
      return (before_handler, after_handler) => {
        if (before_handler !== null && after_handler !== null) {
          return `处理人: 从「${before_handler.nickname}」变更为「${after_handler.nickname}」`;
        } else if (before_handler === null && after_handler !== null) {
          return `处理人: 变更为「${after_handler.nickname}」`;
        }
      };
    }
  },
  created() {
    this.getProblemChangelog();
  },
  methods: {
    getProblemChangelog() {
      problemChangelog({ id: this.problemId })
        .then(res => {
          this.changelogs = res.data.items;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.changelog-card {
  margin-top: 16px;
}
/deep/.ant-card-body {
  padding: 16px;
}
</style>
